<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead>
                    <tr>
                        <th @click="clickThead(0)" rowspan="2" style="width:150px;max-width:150px;cursor:pointer">Nama / NIP <img :src="sortIcon[0]" width="8px" height="16px" style="float:right"/></th>
                        <th @click="clickThead(1)" rowspan="2" style="width:50px;max-width:50px;cursor:pointer">Hari <img :src="sortIcon[1]" width="8px" height="16px" style="float:right"/></th>
                        <th @click="clickThead(2)" rowspan="2" style="width:100px;max-width:100px;cursor:pointer">Tanggal <img :src="sortIcon[2]" width="8px" height="16px" style="float:right"/></th>
                        <th colspan="2">Jadwal</th>
                        <th colspan="2">Absensi</th>
                        <th colspan="2">Kantor</th>
                        <th colspan="2">Jarak (meter)</th>
                        <th @click="clickThead(11)" rowspan="2" style="width:50px;max-width:50px;;cursor:pointer">Status <img :src="sortIcon[3]" width="8px" height="16px" style="float:right"/></th>
                    </tr>
                    <tr style="background-color:rgba(244, 244, 244, 1)">
                        <th @click="clickThead(3)" style="width:50px;max-width:50px;cursor:pointer">In <img :src="sortIcon[4]" width="8px" height="16px" style="float:right"/></th>
                        <th @click="clickThead(4)" style="width:50px;max-width:50px;cursor:pointer">Out <img :src="sortIcon[5]" width="8px" height="16px" style="float:right"/></th>
                        <th @click="clickThead(5)" style="width:100px;max-width:100px;cursor:pointer">In <img :src="sortIcon[6]" width="8px" height="16px" style="float:right"/></th>
                        <th @click="clickThead(6)" style="width:100px;max-width:100px;cursor:pointer">Out <img :src="sortIcon[7]" width="8px" height="16px" style="float:right"/></th>
                        <th @click="clickThead(7)" style="width:100px;max-width:100px;cursor:pointer">In <img :src="sortIcon[8]" width="8px" height="16px" style="float:right"/></th>
                        <th @click="clickThead(8)" style="width:100px;max-width:100px;cursor:pointer">Out <img :src="sortIcon[9]" width="8px" height="16px" style="float:right"/></th>
                        <th @click="clickThead(9)" style="width:50px;max-width:50px;cursor:pointer">In <img :src="sortIcon[10]" width="8px" height="16px" style="float:right"/></th>
                        <th @click="clickThead(10)" style="width:50px;max-width:50px;cursor:pointer">Out <img :src="sortIcon[11]" width="8px" height="16px" style="float:right"/></th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id">
                                    <td v-for="(item, index) in td" :key="index" :style="loadStyle(index)">
                                        <template v-if="item != 'action' && item != 'detail'">
                                            <template v-if="item[0].length == 1">
                                                <template v-if="body[item] == 'null' || body[item] == null || body[item] == undefined || body[item] == ''">
                                                    <div class="text-center">
                                                        -
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <template v-if="item == 'status'">
                                                        <template v-if="body[item] == 'wfo' || body[item] == 'WFO'">
                                                            <div title="WFO" class="card-emblem">
                                                                <img :src="iconWfo" width="20px" height="20px" />
                                                            </div>
                                                        </template>
                                                        <template v-if="body[item] == 'wfh' || body[item] == 'WFH'">
                                                            <div title="WFH" class="card-emblem">
                                                                <img :src="iconWfh" width="20px" height="20px" />
                                                            </div>
                                                        </template>
                                                        <template v-if="body[item] == 'wfa' || body[item] == 'WFA'">
                                                            <div title="WFA" class="card-emblem">
                                                                <img :src="iconWfa" width="20px" height="20px" />
                                                            </div>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item == 'jamMasuk'">
                                                            <span>{{separatorTime(body[item])}}</span>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item == 'jamKeluar'">
                                                                <span>{{separatorTime(body[item])}}</span>
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="item == 'lamaKerja'">
                                                                    <span>{{separatorMenit(body[item])}}</span>
                                                                </template>
                                                                <template v-else>
                                                                    <template v-if="item == 'hari'">
                                                                        <div class="ellps">
                                                                            <span :title="body[item]">
                                                                                {{separatorDay(body[item])}}
                                                                            </span>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <div class="ellps">
                                                                            <span :title="body[item]">
                                                                                {{body[item]}}
                                                                            </span>
                                                                        </div>
                                                                    </template>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-if="item[0].length != 1">
                                                <template v-if="item[0] == 'nama'">
                                                    <CRow>
                                                        <CCol sm="12">
                                                            <div class="ellps">
                                                                <span>
                                                                    {{body[item[0]]}}
                                                                </span>
                                                            </div>
                                                        </CCol>
                                                        <CCol sm="12">
                                                            <span style="color:rgba(154, 154, 154, 1);font-size:12px">
                                                                {{body[item[1]]}}
                                                            </span>
                                                        </CCol>
                                                    </CRow>
                                                </template>
                                                <template v-else>
                                                    <template v-if="item[1] == 'absenMasuk'">
                                                        <a v-if="body[item[0]] == null || body[item[0]] == 'null' || body[item[0]] == '' || body[item[0]] == undefined">
                                                            <img class="mr-2" :src="photo" width="32px" height="32px" style="border-radius:50%;background-color:#dcdcdc;object-fit: cover"/>
                                                        </a>
                                                        <a v-else target="_blank" :href="body[item[0]]">
                                                            <img class="mr-2" :src="body[item[0]]" width="32px" height="32px" style="border-radius:50%"/>
                                                        </a>
                                                        <template v-if="body[item[1]] == 'null'">
                                                            -
                                                        </template>
                                                        <template v-else>
                                                            <span v-if="body[item[1]] > data[id].jamMasuk" class="pass">{{separatorTime(body[item[1]])}}</span>
                                                            <span v-else :title="body[item[1]]">{{separatorTime(body[item[1]])}}</span>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item[1] == 'absenKeluar'">
                                                            <a v-if="body[item[0]] == null || body[item[0]] == 'null' || body[item[0]] == '' || body[item[0]] == undefined">
                                                                <img class="mr-2" :src="photo" width="32px" height="32px" style="border-radius:50%;background-color:#dcdcdc;object-fit: cover"/>
                                                            </a>
                                                            <a v-else target="_blank" :href="body[item[0]]">
                                                                <img class="mr-2" :src="body[item[0]]" width="32px" height="32px" style="border-radius:50%"/>
                                                            </a>
                                                            <template v-if="body[item[1]] == 'null'">
                                                                -
                                                            </template>
                                                            <template v-else>
                                                                <span v-if="body[item[1]] < data[id].jamKeluar" class="pass">{{separatorTime(body[item[1]])}}</span>
                                                                <span v-else :title="body[item[1]]">{{separatorTime(body[item[1]])}}</span>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-if="item == 'action' && item != 'detail'">
                                            <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead>
                            <tr>
                                <th @click="clickThead(0)" rowspan="2" style="cursor:pointer">Nama / NIP <img :src="sortIcon[0]" width="8px" height="16px" style="float:right"/></th>
                                <th @click="clickThead(1)" rowspan="2" style="cursor:pointer">Hari <img :src="sortIcon[1]" width="8px" height="16px" style="float:right"/></th>
                                <th @click="clickThead(2)" rowspan="2" style="cursor:pointer">Tanggal <img :src="sortIcon[2]" width="8px" height="16px" style="float:right"/></th>
                                <th colspan="2">Jadwal</th>
                                <th colspan="2">Absensi</th>
                                <th colspan="2">Kantor</th>
                                <th colspan="2">Jarak (meter)</th>
                                <th @click="clickThead(11)" rowspan="2" style=";cursor:pointer">Status <img :src="sortIcon[3]" width="8px" height="16px" style="float:right"/></th>
                            </tr>
                            <tr style="background-color:rgba(244, 244, 244, 1)">
                                <th @click="clickThead(3)" style="cursor:pointer">In <img :src="sortIcon[4]" width="8px" height="16px" style="float:right"/></th>
                                <th @click="clickThead(4)" style="cursor:pointer">Out <img :src="sortIcon[5]" width="8px" height="16px" style="float:right"/></th>
                                <th @click="clickThead(5)" style="cursor:pointer">In <img :src="sortIcon[6]" width="8px" height="16px" style="float:right"/></th>
                                <th @click="clickThead(6)" style="cursor:pointer">Out <img :src="sortIcon[7]" width="8px" height="16px" style="float:right"/></th>
                                <th @click="clickThead(7)" style="cursor:pointer">In <img :src="sortIcon[8]" width="8px" height="16px" style="float:right"/></th>
                                <th @click="clickThead(8)" style="cursor:pointer">Out <img :src="sortIcon[9]" width="8px" height="16px" style="float:right"/></th>
                                <th @click="clickThead(9)" style="cursor:pointer">In <img :src="sortIcon[10]" width="8px" height="16px" style="float:right"/></th>
                                <th @click="clickThead(10)" style="cursor:pointer">Out <img :src="sortIcon[11]" width="8px" height="16px" style="float:right"/></th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id">
                                <td v-for="(item, index) in td" :key="index">
                                    <template v-if="item != 'action' && item != 'detail'">
                                        <template v-if="item[0].length == 1">
                                            <template v-if="body[item] == 'null' || body[item] == null || body[item] == undefined || body[item] == ''">
                                                <div class="text-center">
                                                    -
                                                </div>
                                            </template>
                                            <template v-else>
                                                <template v-if="item == 'status'">
                                                    <template v-if="body[item] == 'wfo' || body[item] == 'WFO'">
                                                        <div title="WFO" class="card-emblem">
                                                            <img :src="iconWfo" width="20px" height="20px" />
                                                        </div>
                                                    </template>
                                                    <template v-if="body[item] == 'wfh' || body[item] == 'WFH'">
                                                        <div title="WFH" class="card-emblem">
                                                            <img :src="iconWfh" width="20px" height="20px" />
                                                        </div>
                                                    </template>
                                                    <template v-if="body[item] == 'wfa' || body[item] == 'WFA'">
                                                            <div title="WFA" class="card-emblem">
                                                                <img :src="iconWfa" width="20px" height="20px" />
                                                            </div>
                                                        </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="item == 'jamMasuk'">
                                                        <span>{{separatorTime(body[item])}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item == 'jamKeluar'">
                                                            <span>{{separatorTime(body[item])}}</span>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item == 'lamaKerja'">
                                                                <span>{{separatorMenit(body[item])}}</span>
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="item == 'hari'">
                                                                    <div class="ellps">
                                                                        <span :title="body[item]">
                                                                            {{separatorDay(body[item])}}
                                                                        </span>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <div class="ellps">
                                                                        <span :title="body[item]">
                                                                            {{body[item]}}
                                                                        </span>
                                                                    </div>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-if="item[0].length != 1">
                                            <template v-if="item[0] == 'nama'">
                                                <CRow>
                                                    <CCol sm="12">
                                                        <div class="ellps">
                                                            <span>
                                                                {{body[item[0]]}}
                                                            </span>
                                                        </div>
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <span style="color:rgba(154, 154, 154, 1);font-size:12px">
                                                            {{body[item[1]]}}
                                                        </span>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-else>
                                                <template v-if="item[1] == 'absenMasuk'">
                                                    <a v-if="body[item[0]] == null || body[item[0]] == 'null' || body[item[0]] == '' || body[item[0]] == undefined">
                                                        <img class="mr-2" :src="photo" width="32px" height="32px" style="border-radius:50%;background-color:#dcdcdc"/>
                                                    </a>
                                                    <a v-else target="_blank" :href="body[item[0]]">
                                                        <img class="mr-2" :src="body[item[0]]" width="32px" height="32px" style="border-radius:50%"/>
                                                    </a>
                                                    <template v-if="body[item[1]] == 'null'">
                                                        -
                                                    </template>
                                                    <template v-else>
                                                        <span v-if="body[item[1]] > data[id].jamMasuk" class="pass">{{separatorTime(body[item[1]])}}</span>
                                                        <span v-else :title="body[item[1]]">{{separatorTime(body[item[1]])}}</span>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="item[1] == 'absenKeluar'">
                                                        <a v-if="body[item[0]] == null || body[item[0]] == 'null' || body[item[0]] == '' || body[item[0]] == undefined">
                                                            <img class="mr-2" :src="photo" width="32px" height="32px" style="border-radius:50%;background-color:#dcdcdc"/>
                                                        </a>
                                                        <a v-else target="_blank" :href="body[item[0]]">
                                                            <img class="mr-2" :src="body[item[0]]" width="32px" height="32px" style="border-radius:50%"/>
                                                        </a>
                                                        <template v-if="body[item[1]] == 'null'">
                                                            -
                                                        </template>
                                                        <template v-else>
                                                            <span v-if="body[item[1]] < data[id].jamKeluar" class="pass">{{separatorTime(body[item[1]])}}</span>
                                                            <span v-else :title="body[item[1]]">{{separatorTime(body[item[1]])}}</span>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                    <template v-if="item == 'action' && item != 'detail'">
                                        <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
export default {
    props: ['data', 'th', 'td', 'styleTable', 'errors'],
    data() {
        return {
            modal: false,
            sortIcon: [],
            photo: require('@/assets/image/images.svg'),
            iconWfh: require('../assets/menu/icon_home.svg'),
            iconWfo: require('../assets/menu/icon_office.svg'),
            iconWfa: require('../assets/menu/icon_anywhere.svg'),
        }
    },
    mounted() {
        this.iconLoad('unsort', 'none')
    },
    watch: {
    },
    methods: {
        clickThead(index) {
            this.$emit('sort', index)
            this.iconLoad('sort', index)
        },
        goEdit(id) {
            this.$emit('edit', id)
        },
        loadStyle(index) {
            if(index == 1 || index == 2 || index == 3 || index == 4 || index == 9 || index == 10 || index == 11) {
                return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index] + ';text-align:center;'
            }
            return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
        },
        iconLoad(type, index) {
            this.sortIcon = []
            let length = this.th.length
            var i = 0
            if (type == 'sort') {
                for(i=0;i<length;i++) {
                    let onPush = ''
                    if(index == i) {
                        onPush = require('../assets/menu/sort_normal.svg')
                    } else {
                        onPush = require('../assets/menu/sort_active.svg')
                    }
                    this.sortIcon.push(onPush)
                }
            } else {
                for(i=0;i<length;i++) {
                    let onPush = require('../assets/menu/sort_active.svg')
                    this.sortIcon.push(onPush)
                }
            }
        },
        separatorMenit(data) {
            let jam = Math.floor(data/60)
            let menit = data%60
            return jam + ' Jam ' + menit + ' Menit'
        },
        separatorTime(value) {
            let val = value.substr(0, 5)
            return val
        },
        separatorDay(value) {
            let val = value.substr(0, 3)
            return val
        }
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    text-align: center;
    padding-top: 8px;
    padding-left: 4px;
    padding-right: 4px;
    padding-bottom: 8px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 4px;
    padding-right: 4px;
}
td,th {
    /* overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap; */
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
.ellps {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.module {
  width: 250px;
  margin: 0 0 1em 0;
  overflow: hidden;
}
.module span {
  margin: 0;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;  
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
.status {
    width: 50px;
    height: 20px;
    color: white;
    border-radius: 4px;
    text-align: center;
}
.statusWfo {
    background-color: rgba(255, 209, 70, 1);
}
.statusWfh {
    background-color: rgba(94, 189, 116, 1);
}
.statusDetail {
    width: 50px;
    height: 20px;
    color: white;
    border-radius: 4px;
    text-align: center;
    background-color: rgba(48, 107, 221, 1);;
}
.details {
    cursor: pointer;
}
.not-pass {
    color: rgba(16, 16, 16, 1)
}
.pass {
    color: rgba(255, 0, 0, 1);
}
.card-emblem {
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    width:40px;
    height:40px;
    border-radius:50%;
}
</style>
